/* wd-flow-mystery: port of wonderful-flow-landing/pages/mystery.html inline
   <script>. WebGL goo-wipe engine + finale notify form. All DOM lookups are
   scoped to #wd-flow-mystery; asset paths come from window.WD_FLOW_ASSETS.mystery
   (see snippets/wd-flow-asset-urls.liquid) instead of relative assets/ paths. */
(function () {
"use strict";
try {

function init() {
var root = document.getElementById("wd-flow-mystery");
if (!root) return;
var ASSETS = (window.WD_FLOW_ASSETS && window.WD_FLOW_ASSETS.mystery) || {};

var stage=root.querySelector("#stage"), cv=root.querySelector("#gl");
var A=root.querySelector("#a"), B=root.querySelector("#b");
var nib=root.querySelector("#nib");
var tick=root.querySelector("#tick"), tickBar=tick.firstElementChild;
var skip=root.querySelector("#skip");
/* straight to the end: land on the water, skip the wiping and the films */
skip.addEventListener("pointerdown",function(e){ e.stopPropagation(); });
skip.addEventListener("click",function(e){
  e.preventDefault(); e.stopPropagation();
  wavey=1; wave=1; finish();
});
var small=matchMedia("(max-width: 760px)").matches;
/* videos/poster are fetched from the Shopify Files CDN, a different origin
   than the storefront. WebGL's texImage2D refuses to read pixels from a
   cross-origin element unless it opted into CORS, so this has to be set
   before src is assigned or the canvas ends up permanently tainted. */
A.crossOrigin="anonymous";
B.crossOrigin="anonymous";
A.poster=ASSETS.poster||"";
A.src=small?(ASSETS.gooMobile||""):(ASSETS.gooDesktop||"");
B.src=small?(ASSETS.cleanMobile||""):(ASSETS.cleanDesktop||"");

var gl=cv.getContext("webgl2",{alpha:false,antialias:false,powerPreference:"high-performance"});
function bail(){ stage.classList.add("flat");
  var f=root.querySelector("#fallback"); f.appendChild(A); A.muted=false; A.play().catch(function(){}); }
if(!gl){ bail(); return; }
gl.getExtension("EXT_color_buffer_float");

/* ---------------- shaders ----------------
   sim   : where the jam has been wiped, and how the sheet is stretched.
   reduce: the same, shrunk to a thumbnail so we can read back how much is clear.
   draw  : the jam on top. The film underneath is a flat plate; it is never
           bent by the cursor, only uncovered.                              */
var VS="#version 300 es\nin vec2 p;out vec2 uv;void main(){uv=p*.5+.5;gl_Position=vec4(p,0,1);}";

var SIM="#version 300 es\nprecision highp float;in vec2 uv;out vec4 o;\
uniform sampler2D f;uniform vec2 px,ptr,pdel;uniform float rad,dt,grab,seal,time,wavey,wave;\
void main(){\
 vec4 s=texture(f,uv);vec2 d=s.xy;float op=s.z;\
 vec2 a=texture(f,uv+vec2(px.x,0)).xy+texture(f,uv-vec2(px.x,0)).xy\
       +texture(f,uv+vec2(0,px.y)).xy+texture(f,uv-vec2(0,px.y)).xy;\
 d=mix(d,a*.25,.46);\
 /* the wipe is not a circle: lobes that slowly writhe, so it reads as something\
    living being pushed aside rather than a brush */\
 vec2 rel=uv-ptr;float ang=atan(rel.y,rel.x+1e-6);\
 float wob=1.0+.40*sin(ang*3.0+time*.7)+.24*sin(ang*5.0-time*1.1)+.14*sin(ang*8.0+time*.4);\
 float rr=rad*wob;\
 float w=exp(-dot(rel/rr,rel/rr)*1.7);\
 d+=pdel*w*grab*24.0;\
 d+=normalize(rel+1e-5)*exp(-dot(rel/rr,rel/rr)*1.3)*grab*.018;\
 d*=pow(mix(0.90,0.010,wavey),dt);\
 /* cleared stays cleared */\
 op=max(op,smoothstep(.04,.62,w)*grab);\
 /* Jam closes in from every edge like a ring shutting. Water does not: it\
    runs in from one corner as a single front with a wobbling lip. */\
 vec2 q2=abs(uv-.5)*2.0;\
 float dia=max(q2.x*.88+q2.y*.62,max(q2.x,q2.y)*.92);\
 float sang=atan(uv.y-.5,uv.x-.5+1e-6);\
 float e1=smoothstep(1.55-seal*1.85-.04, 1.55-seal*1.85+.16, dia+sin(sang*5.0+time*1.7)*.085);\
 float e2=smoothstep(1.55-seal*1.68-.04, 1.55-seal*1.68+.20, dia+sin(sang*3.0-time*1.1)*.11);\
 float e3=smoothstep(1.55-seal*2.02-.04, 1.55-seal*2.02+.13, dia+sin(sang*9.0+time*2.3)*.05);\
 float ring=max(e1,max(e2,e3));\
 /* Where the water has already run, the jam is simply gone. */\
 float ax=uv.x*.35+(1.0-uv.y)*.92;\
 float bo=floor(time*12.0);\
 float wb=sin(ax*9.0+bo*.9)*.045+sin(ax*19.0-bo*1.3)*.022;\
 wb+=sin(uv.y*6.0-1.0)*.155;\
 float wd=ax+wb-(wave*1.95-.52);\
 op=max(op,wavey*step(wd,0.0));\
 op*=1.0-mix(ring,0.0,wavey);\
 o=vec4(clamp(d,-.6,.6),clamp(op,0.,1.),1);}";

var RED="#version 300 es\nprecision highp float;in vec2 uv;out vec4 o;\
uniform sampler2D f;void main(){o=vec4(step(.72,texture(f,uv).z),0,0,1);}";

var DRAW="#version 300 es\nprecision highp float;in vec2 uv;out vec4 o;\
uniform sampler2D f,vid,mark;uniform vec2 px,cov,ptr;uniform float time,press,seal,wavey,wave;uniform uint gseed;\
/* Gradient noise rather than value noise: value noise is built on a square\
   lattice and you can see the grid in it. This has no preferred direction, so\
   the surface reads as poured rather than tiled. */\
uint uhash(uvec3 x){\
 x=x*1664525u+1013904223u;\
 x.x+=x.y*x.z; x.y+=x.z*x.x; x.z+=x.x*x.y;\
 x^=x>>16u;\
 x.x+=x.y*x.z; x.y+=x.z*x.x; x.z+=x.x*x.y;\
 return x.x;}\
vec3 mod289(vec3 x){return x-floor(x*(1./289.))*289.;}\
vec2 mod289(vec2 x){return x-floor(x*(1./289.))*289.;}\
vec3 permute(vec3 x){return mod289(((x*34.)+1.)*x);}\
float snoise(vec2 v){\
 const vec4 C=vec4(.211324865405187,.366025403784439,-.577350269189626,.024390243902439);\
 vec2 i=floor(v+dot(v,C.yy)),x0=v-i+dot(i,C.xx);\
 vec2 i1=(x0.x>x0.y)?vec2(1.,0.):vec2(0.,1.);\
 vec4 x12=x0.xyxy+C.xxzz; x12.xy-=i1;\
 i=mod289(i);\
 vec3 p=permute(permute(i.y+vec3(0.,i1.y,1.))+i.x+vec3(0.,i1.x,1.));\
 vec3 m=max(.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.);\
 m=m*m;m=m*m;\
 vec3 x=2.*fract(p*C.www)-1.,h=abs(x)-.5,ox=floor(x+.5),a0=x-ox;\
 m*=1.79284291400159-.85373472095314*(a0*a0+h*h);\
 vec3 g;g.x=a0.x*x0.x+h.x*x0.y;g.yz=a0.yz*x12.xz+h.yz*x12.yw;\
 return 130.*dot(m,g);}\
void main(){\
 vec4 fs=texture(f,uv);vec2 d=fs.xy;float op=fs.z;\
 float dR=texture(f,uv+vec2(px.x,0)).x,dL=texture(f,uv-vec2(px.x,0)).x;\
 float dU=texture(f,uv+vec2(0,px.y)).y,dD=texture(f,uv-vec2(0,px.y)).y;\
 float div=(dR-dL)+(dU-dD);\
 /* Gradient noise at the same frequencies the surface had before. No domain\
    warping: that marbles it into something swampy rather than thick. */\
 float lobe=snoise(uv*2.6+vec2(time*.020,-time*.015))*.5+.5;\
 float lobe2=snoise(uv*5.5-vec2(time*.030,0.))*.5+.5;\
 float fine=snoise(uv*13.0+vec2(0.,time*.02))*.5+.5;\
 float n=lobe*.28+lobe2*.16;\
 float mk=texture(mark,uv).r;\
 float th=clamp(1.0-div*11.0+n-.14-mk*.30,0.,1.);\
 /* stretched jam holds together as a strand */\
 th+=smoothstep(.04,.26,length(d))*.20;\
 /* it pools in the corners and runs thin across the middle */\
 vec2 q=abs(uv-.5)*2.0;\
 th+=smoothstep(.45,1.30,length(q))*.55+smoothstep(.75,1.05,max(q.x,q.y))*.20;\
 /* whatever has been wiped is wiped: barely a film left over it */\
 th=min(th,1.0-op*.985);\
 float al=smoothstep(.26,.40,th);\
 /* the plate: straight from the film, never displaced */\
 vec2 c=(uv-.5)*cov+.5;\
 vec3 under=texture(vid,clamp(c,0.001,0.999)).rgb;\
 float veil=clamp(th*2.2,0.,1.);\
 under=mix(under,vec3(.044,.024,.086),veil*.80);\
 under*=1.0-veil*.12;\
 vec3 deep=vec3(.029,.011,.057),mid=vec3(.094,.038,.163),lift=vec3(.318,.180,.462);\
 vec3 jam=mix(deep,mid,smoothstep(.28,1.05,th));\
 jam=mix(jam,lift,smoothstep(.62,.98,lobe)*.42);\
 /* wet sheen off the slope of the sheet */\
 float slope=length(vec2(dR-dL,dU-dD))*46.0;\
 jam+=vec3(.34,.21,.50)*smoothstep(.30,1.0,slope)*.58;\
 jam+=lift*smoothstep(.54,.32,th)*.40;\
 /* the imprint, lit as a surface rather than stamped with a hard shadow */\
 vec2 mo=vec2(px.x,px.y)*.9;\
 float mL=texture(mark,uv-vec2(mo.x,0)).r,mR=texture(mark,uv+vec2(mo.x,0)).r;\
 float mD=texture(mark,uv-vec2(0,mo.y)).r,mU=texture(mark,uv+vec2(0,mo.y)).r;\
 vec3 nrm=normalize(vec3((mR-mL)*2.2,(mU-mD)*2.2,1.0));\
 vec3 Ldir=normalize(vec3(-.42,.58,.70));\
 float dif=max(dot(nrm,Ldir),0.0);\
 float spec=pow(max(dot(reflect(-Ldir,nrm),vec3(0.,0.,1.)),0.0),26.0);\
 jam*=1.0-mk*.30;\
 jam+=lift*dif*mk*.75;\
 jam+=vec3(.64,.52,.86)*spec*mk*.70;\
 jam+=vec3(.022,.011,.038)*(fine-.5)*.55;\
 /* Pressing lifts the whole sheet rather than shining a light on part of it:\
    the ground itself comes up, only a shade more where the hand is, and the\
    ridges catch a little extra so the material reads as responding. */\
 vec2 pr=(uv-ptr)*vec2(px.y/px.x,1.0);\
 float near=.62+.38*exp(-dot(pr,pr)*2.4);\
 jam+=vec3(.30,.17,.50)*near*press*.17;\
 jam+=vec3(.28,.16,.46)*smoothstep(.30,1.0,slope)*press*.30;\
 vec3 col=mix(under,jam,al);\
 /* The water is its own flat drawing on top: hard edges, a few flat bands and\
    white foam lobes, wobbling on twelves the way the films do. */\
 /* The water is its own cel drawing over everything: flat color, an inked\
    edge, outlines jittering on twelves. Nothing in it is lit. */\
 if(wavey>.5){\
  float bo=floor(time*12.0);\
  /* ripples: the sheet's displacement nudges where the water is sampled */\
  vec2 rp=uv+d*.75;\
  /* Same treatment as the jam, in blue: a smooth field with real depth and a\
     gloss off its own slope. Flat vector bands read as camouflage, not water. */\
  vec2 wq=vec2(rp.x*1.15+snoise(vec2(rp.y*2.1,time*.035))*.24, rp.y*3.4+time*.022);\
  float e=.006;\
  float wn =snoise(wq)*.5+.5;\
  float wnx=snoise(wq+vec2(e,0.))*.5+.5;\
  float wny=snoise(wq+vec2(0.,e))*.5+.5;\
  float wn2=snoise(wq*2.05+vec2(4.2,0.))*.5+.5;\
  float wt=wn*.66+wn2*.34;\
  vec3 wInk=vec3(.024,.153,.353);\
  vec3 wDeep=vec3(.016,.161,.412),wMid=vec3(.078,.353,.667),wPale=vec3(.243,.561,.831);\
  vec3 water=mix(wDeep,wMid,smoothstep(.22,.78,wt));\
  water=mix(water,wPale,smoothstep(.66,.96,wn2)*.48);\
  vec3 wnrm=normalize(vec3((wnx-wn)*46.,(wny-wn)*46.,1.));\
  vec3 wL=normalize(vec3(-.40,.58,.71));\
  water+=vec3(.26,.44,.64)*max(dot(wnrm,wL),0.)*.15;\
  float wspec=pow(max(dot(reflect(-wL,wnrm),vec3(0.,0.,1.)),0.),20.);\
  water+=vec3(.52,.70,.88)*wspec*.20;\
  /* a press does not spotlight the water, it makes the whole surface shimmer */\
  vec2 pr2=(uv-ptr)*vec2(px.y/px.x,1.0);\
  /* nearly even across the whole surface, and mostly a flat lift rather than a\
     hit on the crests: the specular is what was making it contrasty */\
  float shim=press*(.86+.14*exp(-dot(pr2,pr2)*1.1));\
  water+=vec3(.55,.74,.95)*wspec*shim*.26;\
  water+=vec3(.20,.36,.55)*shim*.13;\
  float ax=uv.x*.35+(1.0-uv.y)*.92;\
  float wb=sin(ax*9.0+bo*.9)*.045+sin(ax*19.0-bo*1.3)*.022;\
  /* one long S across the height, so the front curves rather than raking */\
  wb+=sin(uv.y*6.0-1.0)*.155;\
  float lob=snoise(vec2(uv.x*4.2,bo*.55))*.070+snoise(vec2(uv.x*10.0,bo*.8+7.0))*.034;\
  float dd=ax+wb+lob*.5-(wave*1.95-.52);\
  float body =step(dd,0.0);\
  float ink  =step(dd,.012)-step(dd,0.0);\
  /* One unbroken mass of whitewater with a ragged outer edge, then a lighter\
     wash starting exactly where it ends. Two separate bands left a gap you could\
     see the ground through, which is what made the foam read as cut-out shapes. */\
  float fEdge=.215+lob*3.1;\
  float foam1=step(dd,fEdge)-step(dd,.012);\
  float foam2=step(dd,fEdge+.115+lob*1.5)-step(dd,fEdge);\
  col=mix(col,water,body);\
  col=mix(col,vec3(1.),clamp(foam1+foam2*.55,0.,1.));\
  col=mix(col,wInk,ink*.9);\
 }\
 /* film grain over everything, re-rolled every frame from the pixel index */\
 float gr=float(uhash(uvec3(uvec2(gl_FragCoord.xy),gseed))&65535u)/65535.;\
 col+=(gr-.5)*.055;\
 o=vec4(col,1);}";

function sh(t,src){var x=gl.createShader(t);gl.shaderSource(x,src);gl.compileShader(x);
 if(!gl.getShaderParameter(x,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(x));return x;}
function prog(v,f){var p=gl.createProgram();gl.attachShader(p,sh(gl.VERTEX_SHADER,v));
 gl.attachShader(p,sh(gl.FRAGMENT_SHADER,f));gl.linkProgram(p);
 if(!gl.getProgramParameter(p,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(p));return p;}
var pSim,pRed,pDraw;
try{pSim=prog(VS,SIM);pRed=prog(VS,RED);pDraw=prog(VS,DRAW);}catch(e){bail();return;}

var vao=gl.createVertexArray();gl.bindVertexArray(vao);
var vb=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,vb);
gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
gl.enableVertexAttribArray(0);gl.vertexAttribPointer(0,2,gl.FLOAT,false,0,0);

function tex(w,h,ifmt,typ,filt){
  var t=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,t);
  gl.texImage2D(gl.TEXTURE_2D,0,ifmt,w,h,0,gl.RGBA,typ,null);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,filt);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,filt);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
  return t;
}
var vTex=gl.createTexture();
gl.bindTexture(gl.TEXTURE_2D,vTex);
gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([18,6,20,255]));
var plateReady=false, poster=new Image();
poster.crossOrigin="anonymous";
poster.onload=function(){
  gl.bindTexture(gl.TEXTURE_2D,vTex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,poster);
  plateReady=true;
};
if(ASSETS.poster) poster.src=ASSETS.poster;
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);

var SW,SH,fb=[],tx=[],cur=0,RW=40,RH=24,rFB,rTX,rBuf=new Uint8Array(RW*RH*4);
var DPR=Math.min(devicePixelRatio||1,1.5);
var markC=document.createElement("canvas"), markTex=gl.createTexture();

var markOn=true;
function buildMark(){
  var w=512,h=Math.max(160,Math.round(512/(innerWidth/innerHeight)));
  markC.width=w;markC.height=h;
  var m=markC.getContext("2d");
  m.fillStyle="#000";m.fillRect(0,0,w,h);
  /* one word, pressed into the jam. No hole: the surface is unbroken until
     they do something about it. */
  m.textAlign="center";m.textBaseline="middle";
  /* the mark maps onto the viewport, so on a tall screen the same width-relative
     size reads much smaller. Give portrait a bigger face and tighter tracking. */
  /* a phone has no press to speak of, so it just gets the verb */
  var tall=h>w, word=(innerWidth<=760)?"WIPE":"PRESS & WIPE";
  m.font="800 "+Math.round(w*(tall?(word.length<6?.145:.077):.053))+"px "+
    "\"Arial Rounded MT Bold\", \"SF Pro Rounded\", HelveticaNow, Helvetica, Arial, sans-serif";
  m.letterSpacing=tall?(word.length<6?"0.28em":"0.14em"):"0.22em";
  m.lineJoin="round";m.lineCap="round";
  /* stroke then fill, so the letterforms carry a soft rounded shoulder */
  m.strokeStyle="rgba(255,255,255,.42)";m.lineWidth=Math.round(w*(tall?(word.length<6?.034:.020):.014));
  m.strokeText(word,w/2+w*(tall?(word.length<6?.014:.007):.011),h/2);
  m.fillStyle="rgba(255,255,255,.80)";
  m.fillText(word,w/2+w*(tall?(word.length<6?.014:.007):.011),h/2);
  gl.bindTexture(gl.TEXTURE_2D,markTex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,markC);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
}
function showMark(){ markOn=true; buildMark(); }
function clearMark(){ markOn=false; var m=markC.getContext("2d"); m.fillStyle="#000"; m.fillRect(0,0,markC.width,markC.height);
  gl.bindTexture(gl.TEXTURE_2D,markTex); gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,markC); }

function size(){
  cv.width=Math.round(innerWidth*DPR);cv.height=Math.round(innerHeight*DPR);
  var ar=innerWidth/innerHeight;
  SW=Math.round(Math.min(360,Math.sqrt(56000*ar)));SH=Math.max(2,Math.round(SW/ar));
  fb.forEach(function(x){gl.deleteFramebuffer(x)});tx.forEach(function(x){gl.deleteTexture(x)});
  fb=[];tx=[];
  for(var i=0;i<2;i++){
    var t=tex(SW,SH,gl.RGBA16F,gl.HALF_FLOAT,gl.LINEAR),f=gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER,f);
    gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_2D,t,0);
    gl.clearColor(0,0,0,1);gl.clear(gl.COLOR_BUFFER_BIT);
    tx.push(t);fb.push(f);
  }
  if(rFB)gl.deleteFramebuffer(rFB); if(rTX)gl.deleteTexture(rTX);
  rTX=tex(RW,RH,gl.RGBA8,gl.UNSIGNED_BYTE,gl.LINEAR);rFB=gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER,rFB);
  gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_2D,rTX,0);
  gl.bindFramebuffer(gl.FRAMEBUFFER,null);
  nib.style.setProperty("--nib",(Math.min(innerWidth,innerHeight)*.15)+"px");
}
addEventListener("resize",function(){size();buildMark();},{passive:true});
size();buildMark();

/* ---------------- pointer ---------------- */
var mx=.5,my=.5,pmx=.5,pmy=.5,down=false,seen=false;
function at(e){lastAct=performance.now();var r=cv.getBoundingClientRect();
  mx=(e.clientX-r.left)/r.width;my=1-(e.clientY-r.top)/r.height;
  if(!seen){seen=true;pmx=mx;pmy=my;}
  nib.style.transform="translate3d("+(e.clientX-r.left)+"px,"+(e.clientY-r.top)+"px,0)";}
stage.addEventListener("pointermove",at,{passive:true});
var warmed=false;
function warm(){
  if(warmed)return; warmed=true;
  /* phones hold off downloading video until a gesture; nudge both so the plate
     is there by the time it is wanted */
  [A,B].forEach(function(v){
    v.muted=true;
    var pr=v.play();
    if(pr&&pr.then) pr.then(function(){ if(act.indexOf("play")!==0) v.pause(); }).catch(function(){});
  });
}
stage.addEventListener("pointerdown",function(e){
  at(e);down=true;unlock();sfxInit();warm();
  if(act!=="over") gloop(true);
  stage.classList.add("pulling");
});
addEventListener("pointerup",function(){
  if(down&&act!=="over") gloop(false);
  down=false;
  stage.classList.remove("pulling");
});
addEventListener("keydown",unlock);

/* Sound needs a real gesture before a browser will allow it. Pressing is what
   clears the jam, so by the time anything is revealed we have one. */
var unlocked=false;
function unlock(){
  if(unlocked)return; unlocked=true;
  document.documentElement.setAttribute("data-audio","playing");
  [A,B].forEach(function(v){ v.muted=false; v.volume=0; });
}

/* ---------------- gloop ----------------
   A quiet squelch under the fingers: a noise bed through a wandering bandpass
   whose level follows how fast you are dragging, plus a soft low thud on press
   and a plop on release. Synthesised, so it is independent of the films. */
var sfx=null;
function sfxInit(){
  if(sfx!==null) return;
  try{
    var AC=window.AudioContext||window.webkitAudioContext;
    if(!AC){ sfx=false; return; }
    var c=new AC(); c.resume();
    var out=c.createGain(); out.gain.value=.60; out.connect(c.destination);

    var len=Math.floor(c.sampleRate*2), buf=c.createBuffer(1,len,c.sampleRate), d=buf.getChannelData(0);
    var lastv=0;
    for(var i=0;i<len;i++){ var w=Math.random()*2-1; lastv=(lastv+.02*w)/1.02; d[i]=lastv*3.2; }

    var src=c.createBufferSource(); src.buffer=buf; src.loop=true;
    var bp=c.createBiquadFilter(); bp.type="bandpass"; bp.frequency.value=420; bp.Q.value=1.7;
    var lp=c.createBiquadFilter(); lp.type="lowpass"; lp.frequency.value=1400;
    var g=c.createGain(); g.gain.value=0;
    src.connect(bp); bp.connect(lp); lp.connect(g); g.connect(out);
    src.start();
    sfx={c:c,out:out,bp:bp,g:g};
    hookFilms(c);
  }catch(e){ sfx=false; }
}

/* The films' own soundtracks, fetched and decoded rather than played off the
   video elements. */
var track={a:null,b:null}, playing=null, trackGain=null, trackLP=null;
function hookFilms(c){
  if(trackGain) return;
  trackGain=c.createGain(); trackGain.gain.value=1; trackGain.connect(c.destination);
  trackLP=c.createBiquadFilter(); trackLP.type="lowpass"; trackLP.Q.value=.7;
  trackLP.frequency.value=20000; trackLP.connect(trackGain);
  [["a",ASSETS.gooAudio],["b",ASSETS.cleanAudio]].forEach(function(pair){
    if(!pair[1]) return;
    fetch(pair[1]).then(function(r){return r.arrayBuffer();})
      .then(function(ab){ return c.decodeAudioData(ab); })
      .then(function(buf){ track[pair[0]]=buf; })
      .catch(function(){});
  });
}
function startTrack(id,offset){
  stopTrack();
  if(!sfx||!sfx.c||!track[id]||!trackGain) return;
  var n=sfx.c.createBufferSource();
  n.buffer=track[id]; n.connect(trackLP||trackGain);
  try{ n.start(0, Math.max(0,offset||0)); }catch(e){ return; }
  playing=n;
}
function stopTrack(){ if(playing){ try{playing.stop();}catch(e){} playing=null; } }
function gloop(down){
  if(!sfx) return;
  var c=sfx.c, t=c.currentTime;
  var o=c.createOscillator(), og=c.createGain();
  o.type="sine";
  o.frequency.setValueAtTime(down?150:120,t);
  o.frequency.exponentialRampToValueAtTime(down?52:44,t+(down?.20:.16));
  og.gain.setValueAtTime(0.0001,t);
  og.gain.exponentialRampToValueAtTime(down?.85:.58,t+.012);
  og.gain.exponentialRampToValueAtTime(0.0001,t+(down?.26:.20));
  o.connect(og); og.connect(sfx.out); o.start(t); o.stop(t+.3);
}
function sfxDrag(speed,pressed){
  if(!sfx) return;
  var t=sfx.c.currentTime;
  var target=pressed?Math.min(.9,speed*9.0+.12):Math.min(.24,speed*3.2);
  sfx.g.gain.setTargetAtTime(target,t,.07);
  sfx.bp.frequency.setTargetAtTime(260+Math.min(1,speed*9)*520,t,.10);
}

/* ---------------- the story ----------------
   jam -> press and wipe half of it away and the film starts, quiet -> louder as
   more comes off -> the jam floods back over the end of it -> wipe again for the
   second film -> the jam wins, and all that is left is the invite. */
var PLAY_AT=.50, PLAY_AT2=.15, SEAL_LEAD=.5, SEAL_WAVE=1.05;
/* Nobody should get stuck looking at jam. If they stop touching it, the invite
   comes up on its own: generously on the opening screen, quickly once they have
   already seen a film and are just sitting there. */
var IDLE_OPEN=30000, ACT2_CLOCK=10000, act2At=0, lastAct=performance.now();
var trackWanted=null;
var wavey=0, wave=0;
var act="wipe1", reel=A, seal=0, cleared=0, tick=0, sealK=1, pressK=0, last=performance.now(), t0=last;
A.loop=false;B.loop=false;A.muted=true;B.muted=true;A.volume=0;B.volume=0;

function beginSeal(){ if(act.indexOf("play")!==0)return; act=act==="play1"?"seal1":"seal2"; if(act==="seal2") clearMark(); }
function stopTick(){ stage.classList.remove("ticking"); }
function finish(){
  if(act==="over")return;
  stopTick();
  act="over"; stopTrack(); clearMark();
  A.pause(); B.pause();
  stage.classList.remove("live"); stage.classList.add("over");
}
A.addEventListener("ended",beginSeal); B.addEventListener("ended",beginSeal);

/* k 0 = still buried, k 1 = in the clear. Eased, so a fast scrub still gives you
   an audible ramp up rather than jumping straight to full. */
/* The soundtrack comes in at 30 percent and lifts to 80 over half a second.
   Eighty is the ceiling: it never runs at full. */
var VOL_MAX=.80, VOL_IN=.30, VOL_RAMP=.5;
function soundIn(){
  if(!trackGain||!sfx||!sfx.c) return;
  var t=sfx.c.currentTime;
  trackGain.gain.cancelScheduledValues(t);
  trackGain.gain.setValueAtTime(VOL_IN,t);
  trackGain.gain.linearRampToValueAtTime(VOL_MAX,t+VOL_RAMP);
  if(trackLP){ trackLP.frequency.cancelScheduledValues(t); trackLP.frequency.setValueAtTime(20000,t); }
}
/* level 1 to 0, used by the wave taking it back under */
function setSound(level){
  if(!trackGain||!sfx||!sfx.c) return;
  var t=sfx.c.currentTime;
  trackGain.gain.cancelScheduledValues(t);
  trackGain.gain.setTargetAtTime(VOL_MAX*level,t,.08);
  /* as the water takes it, the sound goes under with it */
  if(trackLP){
    trackLP.frequency.cancelScheduledValues(t);
    trackLP.frequency.setTargetAtTime(300*Math.pow(58,level),t,.10);
  }
}

function measure(){
  gl.useProgram(pRed);gl.bindVertexArray(vao);
  gl.bindFramebuffer(gl.FRAMEBUFFER,rFB);gl.viewport(0,0,RW,RH);
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tx[cur]);
  gl.uniform1i(gl.getUniformLocation(pRed,"f"),0);
  gl.drawArrays(gl.TRIANGLES,0,3);
  gl.readPixels(0,0,RW,RH,gl.RGBA,gl.UNSIGNED_BYTE,rBuf);
  var n=0;for(var i=0;i<rBuf.length;i+=4)n+=rBuf[i];
  var v=n/(RW*RH*255); return v;
}

var uS={},uD={};
["f","px","ptr","pdel","rad","dt","grab","seal","time","wavey","wave"].forEach(function(k){uS[k]=gl.getUniformLocation(pSim,k)});
["f","vid","mark","px","cov","ptr","time","press","gseed","seal","wavey","wave"].forEach(function(k){uD[k]=gl.getUniformLocation(pDraw,k)});

function frame(now){
  requestAnimationFrame(frame);
  var dt=Math.min(.05,(now-last)/1000);last=now;
  var T=(now-t0)/1000;

  if(++tick%8===0 && act.indexOf("wipe")===0) cleared=measure();

  /* idle fallbacks */
  if(act==="wipe1" && now-lastAct>IDLE_OPEN) finish();
  else if(act==="wipe2" && act2At && now-act2At>ACT2_CLOCK) finish();

  /* the film starts once half of it is gone, and comes up as you clear more */
  /* start muted so it always runs, and let the audio in as soon as we are allowed */
  if(act==="wipe1"&&cleared>=PLAY_AT){ act="play1";reel=A;sealK=1;clearMark();
    A.muted=true;A.play().catch(function(){});
    startTrack("a",A.currentTime); soundIn(); trackWanted="a"; }
  if(act==="wipe2"&&cleared>=PLAY_AT2){ act="play2";reel=B;sealK=1;stopTick();
    B.muted=true;B.play().catch(function(){});
    startTrack("b",B.currentTime); soundIn(); trackWanted="b"; }

  if(act.indexOf("play")===0){
    if(tick%8===0) cleared=measure();
    /* if the file decoded after the film began, pick it up in step */
    if(trackWanted&&!playing&&track[trackWanted]){ startTrack(trackWanted,reel.currentTime); soundIn(); }
    var left=(reel.duration||6)-reel.currentTime;
    if(left<=(act==="play2"?SEAL_LEAD+.5:SEAL_LEAD)) beginSeal();
  }

  if(act==="seal2"){
    wave=Math.min(1,wave+dt/SEAL_WAVE);
    sealK=Math.max(0,sealK-dt/SEAL_WAVE); setSound(sealK);
    if(sealK<=0) stopTrack();
    if(wave>=1){ reel.pause(); act="over"; clearMark(); stage.classList.add("over"); }
  } else if(act==="seal1"){
    seal=Math.min(1,seal+dt/SEAL_LEAD);
    sealK=Math.max(0,sealK-dt/SEAL_LEAD); setSound(sealK);
    if(sealK<=0) stopTrack();
    if(seal>=1){
      reel.pause();
      act="wipe2";seal=0;cleared=0;lastAct=now;showMark();
      act2At=now;
      stage.classList.add("ticking");
      tickBar.style.transition="none"; tickBar.style.transform="scaleX(1)";
      requestAnimationFrame(function(){
        tickBar.style.transition="transform "+(ACT2_CLOCK/1000)+"s linear";
        tickBar.style.transform="scaleX(0)";
      });
    }
  }

  if(reel.readyState>=2 && reel.videoWidth){
    gl.bindTexture(gl.TEXTURE_2D,vTex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,reel);
    plateReady=true;
  }

  gl.useProgram(pSim);gl.bindVertexArray(vao);
  gl.bindFramebuffer(gl.FRAMEBUFFER,fb[1-cur]);gl.viewport(0,0,SW,SH);
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tx[cur]);
  gl.uniform1i(uS.f,0);
  gl.uniform2f(uS.px,1/SW,1/SH);
  gl.uniform2f(uS.ptr,mx,my);
  gl.uniform2f(uS.pdel,mx-pmx,my-pmy);
  gl.uniform1f(uS.rad, act==="over" ? (small?.44:.36) : (small?.26:.20));
  gl.uniform1f(uS.dt,dt);
  gl.uniform1f(uS.grab, act==="over" ? (seen?(down?.050:.017):0)
    : (act.indexOf("seal")===0 ? 0 : (seen?(down?1:.16):0)));
  gl.uniform1f(uS.seal,seal);
  gl.uniform1f(uS.time,T);
  gl.uniform1f(uS.wavey,wavey);
  gl.uniform1f(uS.wave,wave);
  gl.drawArrays(gl.TRIANGLES,0,3);
  sfxDrag(act==="over"?0:Math.hypot(mx-pmx,my-pmy),act==="over"?false:down);
  pmx=mx;pmy=my;cur=1-cur;

  gl.useProgram(pDraw);
  gl.bindFramebuffer(gl.FRAMEBUFFER,null);gl.viewport(0,0,cv.width,cv.height);
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tx[cur]);gl.uniform1i(uD.f,0);
  gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,vTex);gl.uniform1i(uD.vid,1);
  gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_2D,markTex);gl.uniform1i(uD.mark,2);
  gl.uniform2f(uD.px,1/SW,1/SH);
  var vw=reel.videoWidth||poster.naturalWidth||1,vh=reel.videoHeight||poster.naturalHeight||1;
  var cx=Math.min((cv.width/cv.height)/(vw/vh),1), cy=Math.min((vw/vh)/(cv.width/cv.height),1);
  /* A square film cover-cropped into a tall phone shows less than half its
     width, which cuts the words in the artwork. Squeeze it horizontally so
     96.5 percent of the frame fits instead of cropping to it. */
  if(innerWidth<=760) cx=Math.max(cx,.965);
  gl.uniform2f(uD.cov,cx,cy);
  gl.uniform1f(uD.time,T);
  gl.uniform2f(uD.ptr,mx,my);
  pressK+=((down?1:0)-pressK)*Math.min(1,dt/0.09);
  gl.uniform1f(uD.press,pressK);
  gl.uniform1ui(uD.gseed,(Math.random()*4294967295)>>>0);
  /* the second wave is water, not jam */
  wavey=(act==="seal2"||(act==="over"&&wavey>.5))?1:0;
  gl.uniform1f(uD.seal,seal);
  gl.uniform1f(uD.wavey,wavey);
  gl.uniform1f(uD.wave,wave);
  gl.drawArrays(gl.TRIANGLES,0,3);
}
requestAnimationFrame(frame);

/* Notify form is bound by assets/wd-flow-klaviyo.js. */
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",init);
}else{
  init();
}

}catch(err){
  if(window.console) console.error("[wd-flow-mystery] init failed",err);
}
})();
